import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { Activity as ActivityIcon, Loader2 } from "lucide-react";

export default function ActivityPage() {
  const [items, setItems] = useState(null);
  const { t } = useI18n();
  useEffect(() => { api.activity().then(setItems); }, []);
  if (!items) return <div className="flex items-center justify-center py-32"><Loader2 className="animate-spin text-[#2563EB]" /></div>;
  return (
    <div className="space-y-6">
      <div>
        <p className="mono-label">{t("act.label")}</p>
        <h1 className="font-display text-3xl font-extrabold text-white mt-1 flex items-center gap-2"><ActivityIcon className="text-[#2563EB]" /> {t("act.title")}</h1>
        <p className="text-sm text-[#94A3B8] mt-1">{t("act.subtitle")}</p>
      </div>
      <div className="m-card p-5">
        {items.length === 0 ? <p className="text-sm text-[#64748B]">{t("act.empty")}</p> : (
          <div className="relative pl-6">
            <div className="absolute left-[7px] top-2 bottom-2 w-px bg-[#1E293B]" />
            <div className="space-y-4">
              {items.map((a) => (
                <div key={a.id} className="relative" data-testid={`activity-${a.id}`}>
                  <div className="absolute -left-[22px] top-1.5 h-3 w-3 rounded-full bg-[#2563EB] border-2 border-[#0F1626]" />
                  <div className="flex items-center gap-2 flex-wrap"><span className="m-pill text-[#60A5FA]" style={{ borderColor: "#1E293B", background: "#0B0F19" }}>{a.action}</span><span className="text-[10px] text-[#64748B] font-mono">{a.project_code || "—"}</span></div>
                  <p className="text-sm text-[#E2E8F0] mt-1.5">{a.detail}</p>
                  <p className="text-[10px] text-[#64748B] font-mono mt-0.5">{a.actor} · {new Date(a.created_at).toLocaleString()}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
